module.exports = __webpack_public_path__ + "static/media/arctic@2x.08fafadd.png";